// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__kFH-x","list":"styles_list__1T9o3"};